import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import shouldPureComponentUpdate from 'react-pure-render/function';
import Immutable from 'immutable';

import config from 'config/global';
import InlineSVG from 'svg-inline-react';
import { toggleModal } from 'actions/modalActions';
import * as optimizelyUtil from 'utils/optimizely';

import closeIcon from 'static/icons/close.svg';

import './ResponsiveGallery.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  appState: state.appState,
});

function mapDispatchToProps(dispatch) {
  return {
    toggleModalBound: () => dispatch(toggleModal('')),
  };
}

export class ResponsiveGallery extends Component {
  static propTypes = {
    images: PropTypes.object.isRequired,
    mainImageType: PropTypes.oneOf(['DGA', 'RTB', 'RGA', 'RGL', 'RGXL', 'INS', 'FLX']),
    toggleModalBound: PropTypes.func.isRequired,
    loopImages: PropTypes.bool,
  };

  static defaultProps = {
    images: Immutable.Map(),
    mainImageType: 'FLX',
    loopImages: true,
  };

  state = {
    currentImageIndex: 0,
  }

  componentDidMount() {
    window.addEventListener('keyup', this.closeModalWithEscape);
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  componentWillUnmount() {
    window.removeEventListener('keyup', this.closeModalWithEscape);
  }

  get isFirstImage() {
    return this.state.currentImageIndex === 0;
  }

  get isLastImage() {
    const { images } = this.props;
    return this.state.currentImageIndex === images.size - 1;
  }

  get currentImageUrl() {
    const { images, mainImageType } = this.props;
    const index = this.currentImageIndex;

    const imagesArray = images.toJS();
    const availableImageType = images.getIn([`${index}`, 'sizes', mainImageType], false) ? mainImageType : 'DGA';

    let imagePathname = typeof imagesArray[index] === 'string' ? imagesArray[index] : imagesArray[index].location;
    imagePathname = imagePathname ? imagePathname.replace(/(^.+)(\.[A-Z]{3})(\.jpg)$/, '$1$3').replace('.jpg', `.${availableImageType}.jpg`) : '';

    const isFullURL = imagePathname.indexOf('http') === 0;

    return `${isFullURL ? '' : config.imagesBaseUrl}${imagePathname}`;
  }

  get totalImages() {
    const { images } = this.props;
    return images.size;
  }

  get currentImageIndex() {
    return this.state.currentImageIndex;
  }

  get currentImageDisplayIndex() {
    return this.state.currentImageIndex + 1;
  }

  onPrevClick = (event) => {
    const { images, loopImages } = this.props;
    const prevFromFirst = loopImages ? images.size - 1 : 0;

    if (event) {
      event.preventDefault();
    }

    this.setState({
      currentImageIndex: this.currentImageIndex !== 0 ? this.currentImageIndex - 1 : prevFromFirst,
    });
  }

  onNextClick = (event) => {
    const { images, loopImages } = this.props;
    const nextFromLast = loopImages ? 0 : images.size - 1;

    if (event) {
      event.preventDefault();
    }

    this.setState({
      currentImageIndex: this.currentImageIndex < images.size - 1 ? this.currentImageIndex + 1 : nextFromLast,
    });
  }

  closeModal = (event) => {
    event.preventDefault();
    this.props.toggleModalBound(event);
  }

  closeModalWithEscape = (event) => {
    const escapeKeycode = 27;

    if (event.keyCode === escapeKeycode) {
      this.props.toggleModalBound(event);
    }
  }

  trackOptimizely = () => {
    optimizelyUtil.fireEvent('HotelDetailsGallery', 'clicked');
  }

  render() {
    const { images, loopImages } = this.props;

    return images && !!images.size && (
      <div className="responsive-gallery" onClick={this.trackOptimizely}>
        <a href="#" className="responsive-gallery__screen" onClick={this.closeModal} />
        <div className="responsive-gallery__inner">
          <a href="#" className={`responsive-gallery__control responsive-gallery__control--prev ${!loopImages && this.isFirstImage && 'responsive-gallery__control--disabled'}`} onClick={this.onPrevClick}>
            <span className="responsive-gallery__control__icon">previous</span>
          </a>
          <div className="responsive-gallery__content">
            <a href="#" onClick={this.closeModal} className="responsive-gallery__content__close">
              <InlineSVG src={closeIcon} className="responsive-gallery__content__close__icon" />
            </a>
            <img src={this.currentImageUrl} itemProp="photo" className="responsive-gallery__content__image" />
            <p className="responsive-gallery__content__status">
              {this.currentImageDisplayIndex} of {this.totalImages}
            </p>
          </div>
          <a href="#" className={`responsive-gallery__control responsive-gallery__control--next ${!loopImages && this.isLastImage && 'responsive-gallery__control--disabled'}`} onClick={this.onNextClick}>
            <span className="responsive-gallery__control__icon">next</span>
          </a>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveGallery);



/** WEBPACK FOOTER **
 ** ./src/components/ResponsiveGallery/ResponsiveGallery.jsx
 **/